import React from "react";
import Dropdown from "../DropDown";

interface BaseGranularityDropdownProps {
  selectedBaseGranularity: string;
  onBaseGranularityChange: (selectedBaseGranularity: string) => void;
  disabled: boolean;
  className?: string;
  onFocus?: () => void;
}

const BaseGranularityDropdown: React.FC<BaseGranularityDropdownProps> = ({
  selectedBaseGranularity,
  onBaseGranularityChange,
  className = "",
  disabled,
  onFocus,
}) => {
  const options = [
    { value: "15minute", label: "15minute" },
    { value: "5minute", label: "5minute" },
    { value: "day", label: "day" },
    { value: "hour", label: "hour" },
  ];

  return (
    <Dropdown
      options={options}
      selectedValue={selectedBaseGranularity}
      onValueChange={onBaseGranularityChange}
      disabled={disabled}
      className={className}
      placeholder="Select Base Granularity"
      onFocus={onFocus}
    />
  );
};

export default BaseGranularityDropdown;
